module.exports = __webpack_public_path__ + "img/whl.cd0c63e9.png";